/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { Localization } from 'connex-cds';
import { useGetCompanyAdmin } from '../../../../query-hooks/company';
import { useTicketContext } from './TicketContext';

/**
 * Resolves IANA timezone for ticket UI/PDF parity.
 * Priority: ticket.origin → company-admin dateTimeSettings → localization (useMonitorTimeZone) → UTC.
 */
export const useResolvedTicketTimeZone = () => {
  const { ticket } = useTicketContext();
  const { data: companyAdmin } = useGetCompanyAdmin();
  const { timeZone: contextTimeZone } = Localization.useLocalizationContext() ?? {};

  const settingsTimeZone = companyAdmin?.dateTimeSettings?.timeZone;

  return ticket?.origin?.timeZone || settingsTimeZone || contextTimeZone || 'UTC';
};
